import script from "./FileTypeSelectButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileTypeSelectButton.vue?vue&type=script&setup=true&lang=ts"

import "./FileTypeSelectButton.vue?vue&type=style&index=0&id=3408a64e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3408a64e"]])

export default __exports__